import type { FC } from "react";
import classNames from "classnames";
import LinearInfo from "~/features/configurator/Linear/components/LinearInfo";

export const LinearSectionTitle: FC<{ info?: string; addModalParam?: boolean } & JSX.IntrinsicElements["p"]> = ({
  info,
  className,
  children,
  addModalParam,
  // eslint-disable-next-line unused-imports/no-unused-vars
  ...rest
}) => {
  return (
    <p className={classNames("title-medium d-flex flex-align-center", className)}>
      <span>{children}</span>
      <LinearInfo
        className={"ml-1 flex-align-self-start"}
        popupClassName={"scha__lc__external-content--shaft" + (addModalParam ? " scha__lc__kits-table" : "")}
        info={info}
      />
    </p>
  );
};
